import { ApiError } from '@bymason/utils';

export function getErrorCode(error: Error | ApiError) {
  return error instanceof ApiError ? error.code : 0;
}

export function getErrorData<T>(error: Error | ApiError<T>) {
  return error instanceof ApiError ? error.data : undefined;
}

export function getErrorMessage(error: Error | string) {
  return error instanceof Error ? error.message : error;
}
